
/* injects from baggage-loader */


export const imageAgent = require('_images/agent.png');

// Numerals
export const NumeralsI18n = {
  female: {
    1: 'uma',
    2: 'duas',
    3: 'três',
    4: 'quatro',
    5: 'cinco',
    6: 'seis',
    7: 'sete',
    8: 'oito',
    9: 'nove'
  },
  male: {
    1: 'um',
    2: 'dois',
    3: 'três',
    4: 'quatro',
    5: 'cinco',
    6: 'seis',
    7: 'sete',
    8: 'oito',
    9: 'nove'
  }
};

export const bottomRightBallonPosition = {
  bottom: '32px',
  right: '24px'
};

export const topLeftBallonPosition = {
  top: '24px',
  left: '60px'
};

export const topLeftWithStatusBarPosition = {
  top: '128px',
  left: '60px'
};


// Dialogs Thumbs
export const CharThumbs = {
  abeldo: require('_images/dialog-ballons/profiles/abeldo.png'),
  croma: require('_images/dialog-ballons/profiles/croma.png'),
  vernaculo: require('_images/dialog-ballons/profiles/vernaculo.png')
}

export const definitonModal = 'Nos quadrinhos, as <b>sarjetas</b> ou <b>calhas</b> são os <b>espaços</b> em branco entre dois quadrinhos. Esses espaços representam um <b>intervalo de tempo</b> entre o acontecimento de um quadro e o acontecimento do quadro seguinte.'


// WEBPACK FOOTER //
// ./src/app/index.const.js